<template>
    <FormGroup
        :name="name"
        :label="label"
        :as-row="asRow"
        :size="size"
        :required="required"
        :errors="errors"
        :hide-validation="!showValidation">
        <template #default>
            <ToggleInput
                ref="input"
                v-model="model"
                :name="name"
                :required="required"
                v-bind="$attrs" />
        </template>

        <template #tips>
            <slot />
        </template>
    </FormGroup>
</template>

<script>
import FieldMixin from '@/js/mixins/FieldMixin';

import FormGroup from '@/js/components/common/fields/FormGroup';
import ToggleInput from '@/js/components/common/inputs/ToggleInput';

export default {
    name: 'ToggleField',

    components: {FormGroup, ToggleInput},

    mixins: [FieldMixin],

    inheritAttrs: false,

    props: {
        value: {
            type: null,
            default: null,
            validator: (value) => [null, true, false].includes(value),
        },
    },

    methods: {
        format(value) {
            if ((value === true) || (value === false)) {
                return value;
            }

            return null;
        },
    },
};
</script>
